import axios from 'axios';
import qs from 'qs';
import config from '../../config';

const BASE_URL = config.backofficeApiUrl;

const client = axios.create({withCredentials: true});

export const authMe = () => client.get(`${BASE_URL}/auth/me`);
export const authImpersonate = (id) => client.post(`${BASE_URL}/auth/impersonate`, {id});
export const authLogin = (username, password) => client.post(`${BASE_URL}/auth/login`, {username, password});
export const authLogout = () => client.get(`${BASE_URL}/auth/logout`);
export const adminFetchOrganizationList = () => client.get(`${BASE_URL}/admin/organization`);
export const adminFetchUser = (id) => client.get(`${BASE_URL}/admin/user/${id}`);
export const adminFetchUserList = (q, offset, limit, sortBy) =>
    client.get(`${BASE_URL}/admin/user${qs.stringify({q, offset, limit, sortBy}, {addQueryPrefix: true})}`);
export const adminCreateUser = (data) => client.post(`${BASE_URL}/admin/user`, data);
export const adminEditUser = (id, data) => client.put(`${BASE_URL}/admin/user/${id}`, data);
export const fetchAnalytics = (type, params) => client.post(`${BASE_URL}/analytics/${type}`, params);
export const fetchAnalyticsBatch = (requests) => client.post(`${BASE_URL}/analytics/batch`, {requests});
export const fetchDashboard = (id) => client.get(`${BASE_URL}/dashboard/${id}`);
export const fetchOrganization = () => client.get(`${BASE_URL}/organization`);
export const editOrganization = (data) => client.put(`${BASE_URL}/organization`, data);
export const fetchSurveyList = (offset, limit, filter = '', sort = '') =>
    client.get(`${BASE_URL}/survey${qs.stringify({offset, limit, q: filter, sort}, {addQueryPrefix: true})}`);
export const fetchSurvey = (id) => client.get(`${BASE_URL}/survey/${id}`);
export const fetchSurveyTrackers = (surveyId, waveId, offset, limit, sortBy, filter, filterText) =>
    client.get(
        `${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers${qs.stringify({offset, limit, sortBy, filter, filterText}, {addQueryPrefix: true})}`,
    );
export const editSurvey = (id, data) => client.put(`${BASE_URL}/survey/${id}`, data);
export const createSurvey = (data) => client.post(`${BASE_URL}/survey`, data);
export const fetchSurveyTagsSuggestions = (organizationId, text) =>
    client.post(`${BASE_URL}/survey/${organizationId}/tags`, {text});
export const cloneSurvey = (surveyId, data) => client.post(`${BASE_URL}/survey/${surveyId}/clone`, data);
export const deleteSurvey = (id) => client.delete(`${BASE_URL}/survey/${id}`);
export const deleteSurveyTracker = (surveyId, waveId, trackerId) => client.delete(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/${trackerId}`);
export const deleteSurveyTrackers = (surveyId, waveId) => client.delete(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers`);
export const deleteSurveyWave = (surveyId, waveId) => client.delete(`${BASE_URL}/survey/${surveyId}/wave/${waveId}`);
export const deleteSurveyInstances = (id) => client.delete(`${BASE_URL}/survey/${id}/instances`);
export const uploadOrganizationFile = (file) => {
    const data = new FormData();
    data.append('file', file);
    return client.post(`${BASE_URL}/organization/file`, data);
};
export const uploadSurveyFile = (id, file) => {
    const data = new FormData();
    data.append('file', file);
    return client.post(`${BASE_URL}/survey/${id}/file`, data);
};
export const fetchMediaList = (offset, limit, filter = '', sort = '') =>
    client.get(`${BASE_URL}/media${qs.stringify({offset, limit, q: filter, sort}, {addQueryPrefix: true})}`);
export const uploadMedia = (file) => {
    const data = new FormData();
    data.append('file', file);
    return client.post(`${BASE_URL}/media`, data);
};
export const renameMedia = (id, filename) => client.put(`${BASE_URL}/media/${id}`, {filename});
export const deleteMedia = (id) => client.delete(`${BASE_URL}/media/${id}`);
export const fetchMediaUsage = (id) => client.get(`${BASE_URL}/media/${id}/usage`);
export const testSurveyExternalProvider = (data) => client.post(`${BASE_URL}/survey/test-external-provider`, data);
export const uploadSurveyTrackedUsersFile = (surveyId, waveId, file) => {
    const data = new FormData();
    data.append('file', file);
    return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/create-tracked-instances`, data);
};
export const sendTrackedUsersMessages = (surveyId, waveId, data) => {
    if (data.emailBodyHtmlFile) {
        const form = new FormData();
        for (const field in data) {
            if (Object.prototype.hasOwnProperty.call(data, field)) {
                if (Array.isArray(data[field])) {
                    for (const item of data[field]) {
                        form.append(`${field}[]`, item);
                    }
                } else {
                    form.append(field, data[field]);
                }
            }
        }
        return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/send`, form);
    } else {
        return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/send`, data);
    }
};

export const updateAllSurveysTrackersArchive = (data) => client.post(`${BASE_URL}/v1/survey/updateTrackersArchive`, data);

export const saveSurveyTracker = (surveyId, waveId, data) => {
    if (data.emailBodyHtmlFile) {
        const form = new FormData();
        for (const field in data) {
            if (Object.prototype.hasOwnProperty.call(data, field)) {
                if (Array.isArray(data[field])) {
                    for (const item of data[field]) {
                        form.append(`${field}[]`, item);
                    }
                } else {
                    form.append(field, data[field]);
                }
            }
        }
        return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/save`, form);
    } else {
        return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/save`, data);
    }
};

export const testSurveyTracker = (surveyId, waveId, data) => {
    if (data.emailBodyHtmlFile) {
        const form = new FormData();
        for (const field in data) {
            if (Object.prototype.hasOwnProperty.call(data, field)) {
                if (Array.isArray(data[field])) {
                    for (const item of data[field]) {
                        form.append(`${field}[]`, item);
                    }
                } else {
                    form.append(field, data[field]);
                }
            }
        }
        return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/test`, form);
    } else {
        return client.post(`${BASE_URL}/survey/${surveyId}/wave/${waveId}/trackers/test`, data);
    }
};

export const createSurveyWave = (surveyId, data) => client.post(`${BASE_URL}/survey/${surveyId}/wave/create-wave`, data);
export const editSurveyWave = (surveyId, waveId, data) => client.put(`${BASE_URL}/survey/${surveyId}/wave/${waveId}`, data);


export const getDashboardsConfiguration = () => client.get(`${BASE_URL}/dashboard/dashboard-configuration`);
export const getDashboardsEmbeddedUrl = (dashboardId) => client.get(`${BASE_URL}/analytics/embed-url/${dashboardId}`);

const getFileType = (header) => header;
const getFileName = (header) => {
    let name = 'export';
    if (header) {
        const match = header.match(/filename\*=utf-8''"?([^"]+)"?/);
        name = match ? decodeURIComponent(match[1]) : null;
    }
    return name;
};

export const exportSurvey = async (id, params) => {
    let url = `${BASE_URL}/survey/${id}/${params.format}?instanceType=${params.instanceType}`;
    if (params.incomplete && params.incomplete.length > 0) {
        url += `&incomplete=${params.incomplete}`;
    }
    if (params.startDate && params.startDate !== '-') {
        url += `&startDate=${params.startDate}`;
    }
    if (params.endDate && params.endDate !== '-') {
        url += `&endDate=${params.endDate}`;
    }
    const response = await client.get(url, {responseType: 'blob'});
    return {
        name: getFileName(response.headers['content-disposition']),
        type: getFileType(response.headers['content-type']),
        data: response.data,
    };
};

export const exportDashboard = async (id, params) => {
    let url = `${BASE_URL}/dashboard/${id}/${params.startDate}/${params.endDate}/export.xlsx`;
    if (params.instanceType) {
        url += `?instanceType=${params.instanceType}`;
    }
    const response = await client.get(url, {responseType: 'blob'});
    return {
        name: getFileName(response.headers['content-disposition']),
        type: getFileType(response.headers['content-type']),
        data: response.data,
    };
};
